import React, {forwardRef, PropsWithChildren, useMemo} from 'react';
import Toolbar, {Item, ToolbarRef} from "devextreme-react/toolbar";
import dxButton from "devextreme/ui/button";
import IDataSource from "../../models/IDataSource";

export interface IItemOptions {
    text?: string,
    icon?: string,
    visible?: boolean,
    disabled?: boolean,
    click?: (e: any) => void,
}

export interface IFromToolbarProps {
    headerText?: string,
    ajouterOptions?: IItemOptions,
    modifierOptions?: IItemOptions,
    annulerOptions?: IItemOptions,
    effacerOptions?: IItemOptions,
    sauvegarderOptions?: IItemOptions,
    dataController?: IDataSource<any, any>,
    removeBlocked?: boolean,
    codeCampingQuebec?: string
}

const FormListBaseToolbar = forwardRef<ToolbarRef, PropsWithChildren & IFromToolbarProps>(
    ({
         children,
         headerText,
         ajouterOptions,
         modifierOptions,
         annulerOptions,
         effacerOptions,
         sauvegarderOptions,
         dataController,
         removeBlocked,
         codeCampingQuebec
     }, ref): any => {

        const ajouterButtonOtions = useMemo(() => ({
            icon: ajouterOptions?.icon || 'plus',
            text: ajouterOptions?.text || "Ajouter",
            onClick: ajouterOptions?.click,
        }), [ajouterOptions?.click, ajouterOptions?.icon, ajouterOptions?.text])

        const modifierButtonOtions = useMemo(() => ({
            icon: modifierOptions?.icon || 'edit',
            text: modifierOptions?.text || "Modifier",
            onClick: modifierOptions?.click
        }), [modifierOptions?.click, modifierOptions?.icon, modifierOptions?.text])

        const effacerButtonOtions = useMemo(() => ({
            icon: effacerOptions?.icon || 'remove',
            text: effacerOptions?.text || "Effacer",
            onClick: effacerOptions?.click,
        }), [effacerOptions?.icon, effacerOptions?.text, effacerOptions?.click])

        const annulerButtonOtions = useMemo(() => ({
            icon: annulerOptions?.icon || 'revert',
            text: annulerOptions?.text || "Annuler",
            onClick: (e: any) => {
                if (annulerOptions?.click)
                    return annulerOptions.click(e)
                return dataController?.dataSource?.store().byKey(dataController?.selectedId)
            },
        }), [annulerOptions?.click, dataController?.dataSource, dataController?.selectedId, annulerOptions?.text, annulerOptions])

        const sauvegarderButtonOtions = useMemo(() => ({
            icon: sauvegarderOptions?.icon || 'save',
            text: sauvegarderOptions?.text || "Sauvegarder",
            onClick: sauvegarderOptions?.click,
        }), [sauvegarderOptions?.click, sauvegarderOptions?.icon, sauvegarderOptions?.text])

        //console.log(codeCampingQuebec)
        return <>
            <div>
                <div className="toolbar-header">{headerText}</div>
            </div>
            <Toolbar className="toolbar" ref={ref}>
                {ajouterOptions?.visible !== false ? <Item disabled={ajouterOptions?.disabled} key={"def-toolbar-item-ajouter"} location={"before"} widget={"dxButton"} locateInMenu={"auto"} options={ajouterButtonOtions}/> : null}
                {modifierOptions?.visible !== false ? <Item disabled={modifierOptions?.disabled} key={"def-toolbar-item-modifier"} location={"before"} widget={"dxButton"} locateInMenu={"auto"} options={modifierButtonOtions}/> : null}
                {effacerOptions?.visible !== false && !removeBlocked ? <Item disabled={effacerOptions?.disabled} key={"def-toolbar-item-effacer"} location={"before"} widget={"dxButton"} locateInMenu={"auto"} options={effacerButtonOtions}/> : null}
                {sauvegarderOptions?.visible !== false ? <Item disabled={sauvegarderOptions?.disabled} key={"def-toolbar-item-sauvegarder"} location={"before"} widget={"dxButton"} options={sauvegarderButtonOtions}/> : null}
                {annulerOptions?.visible !== false ? <Item disabled={annulerOptions?.disabled} key={"def-toolbar-item-annuler"} location={"before"} widget={"dxButton"} options={annulerButtonOtions}/> : null}
                {children}
                {codeCampingQuebec &&
                    <Item key={"def-toolbar-item-code-camping"} location={"before"} cssClass='def-toolbar-item-code-camping' widget={"dxButton"}
                          options={{
                              text: codeCampingQuebec,
                              // onClick: sauvegarderOptions?.click
                          }}
                    />}
            </Toolbar>
        </>
    }
);
export default FormListBaseToolbar;